import cn from 'classnames';
import styles from './marker.module.scss';
import gsap from 'gsap';
import { useRef, useState, useEffect } from 'react';

const Marker = ({ id, cluster, openMarker, onClick, data }) => {
  const markerContent = useRef(null);
  const [isOpen, setIsOpen] = useState(true);

  const toggleData = (isOpen) => {
    if (!markerContent.current) return;
    gsap.to(markerContent.current, {
      height: isOpen ? 'auto' : '0',
      ease: 'expo.out',
      duration: 0.7
    });
  };

  useEffect(() => {
    const open = id === openMarker;
    setIsOpen(open);
    toggleData(open);
  }, [openMarker, id]);

  const _onClick = () => {
    onClick && onClick(isOpen ? null : id);
  };

  return (
    <div className="relative">
      <button
        onClick={_onClick}
        className={cn(
          'group absolute z-1 w-48 h-48 rounded-full flex items-center justify-center -translate-x-1/2',
          {
            'bg-red bottom-10 left-1/2': !cluster,
            'bg-red bottom-1/2 left-1/2 -translate-y-1/2': cluster
          }
        )}
      >
        {cluster ? (
          <>
            <div className="w-full h-full flex items-center justify-center text-white text-14">
              {cluster}
            </div>
          </>
        ) : (
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="26"
              fill="none"
              viewBox="0 0 22 26"
            >
              <g clipPath="url(#clip0_2478_36690)">
                <path
                  fill="#22CDC6"
                  d="M21.567 4.38a.798.798 0 00-.21-.389c-.015-.015-.032-.028-.048-.042h-.002l-.716-.598-1.986-1.656L17.006.367a.451.451 0 00-.37-.058L.977 4.194a.74.74 0 00-.398.276.796.796 0 00-.167.475v15.89c0 .167.063.304.165.388l4.947 4.121a.62.62 0 00.07.048.459.459 0 00.329.031l15.09-3.743a.624.624 0 00.15-.06.819.819 0 00.416-.692v-3.487s.005.01.01.015V4.569a.797.797 0 00-.022-.189zm-9.71-1.658l4.44-1.103a.197.197 0 01.174.034l2.158 1.8.68.566.36.298c.077.066.022.22-.086.246L15.14 5.666a.185.185 0 01-.172-.035L11.77 2.968c-.076-.064-.022-.22.086-.246zM5.758 7.916l-3.2-2.663c-.076-.064-.022-.22.088-.246l4.425-1.098a.185.185 0 01.173.034l2.84 2.365.36.298c.076.066.022.22-.086.247L5.929 7.95a.183.183 0 01-.17-.035zm14.684 12.416c0 .145-.108.29-.243.324l-4.57 1.133c-.133.033-.243-.057-.243-.202V17.11c0-.147-.109-.237-.244-.203l-3.683.916a.34.34 0 00-.243.321v4.476c0 .145-.107.29-.243.323l-4.57 1.134c-.133.033-.243-.058-.243-.202V9.384c0-.144.11-.29.243-.323l4.57-1.134c.136-.033.243.057.243.204v4.486c0 .147.11.237.243.203l3.683-.912a.35.35 0 00.244-.325V7.096c0-.146.11-.291.243-.324l.348-.086.171-.043.025-.005.659-.163 3.367-.836c.136-.034.243.056.243.202v14.49z"
                ></path>
                <path
                  fill="#FEFEFE"
                  d="M20.443 5.841v14.49c0 .146-.108.29-.243.325l-4.57 1.133c-.134.033-.243-.057-.243-.202V17.11c0-.147-.11-.237-.244-.203l-3.683.916a.34.34 0 00-.243.321v4.476c0 .145-.108.29-.243.323l-4.57 1.134c-.134.033-.243-.058-.243-.202V9.384c0-.144.11-.29.243-.323l4.57-1.134c.135-.033.243.057.243.204v4.486c0 .147.11.237.243.203l3.683-.912a.35.35 0 00.244-.325V7.096c0-.146.11-.291.243-.324l.348-.086.17-.043.025-.005.66-.163 3.367-.836c.135-.034.243.056.243.202zM19.583 4.563L15.14 5.666a.185.185 0 01-.172-.035L11.77 2.968c-.076-.064-.022-.22.086-.246l4.442-1.103a.197.197 0 01.173.034l2.158 1.8.68.566.36.298c.077.066.022.22-.086.246zM10.359 6.853L5.929 7.95a.183.183 0 01-.17-.035l-3.2-2.663c-.076-.064-.022-.22.087-.246l4.426-1.098a.185.185 0 01.173.034l2.84 2.365.36.298c.076.066.021.22-.086.247z"
                ></path>
              </g>
              <defs>
                <clipPath id="clip0_2478_36690">
                  <path
                    fill="#fff"
                    d="M0 0H21.177V25.147H0z"
                    transform="translate(.412 .294)"
                  ></path>
                </clipPath>
              </defs>
            </svg>
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 scale-50 opacity-0 group-hover:scale-100 group-hover:opacity-100 duration-40">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="58"
                height="58"
                fill="none"
                viewBox="0 0 58 58"
              >
                <circle cx="29" cy="29" r="28.5" stroke="#EE4424"></circle>
              </svg>
            </div>
            <div
              className={cn(
                'absolute top-[96%] left-1/2 -translate-x-1/2 w-16 h-8 bg-red group-hover:-translate-y-full duration-40',
                styles.triangleClipPath
              )}
            ></div>
          </>
        )}
      </button>

      {!cluster && (
        <div
          ref={markerContent}
          className="h-0 overflow-hidden absolute -top-70 left-15 shadow-[0px_24px_26px_0px_rgba(206,206,206,0.36)]"
        >
          <div className="relative min-w-[20rem] bg-white py-14 px-22 rounded-[.8rem]">
            <div className="mb-15">
              <p className="p1 !text-12 sm:!text-16 !font-semibold text-black capitalize">
                {data.name}
              </p>
              <p className="p1 !text-11 sm:!text-14 text-cyan-dark capitalize">
                {data.street} {data.door_number}
              </p>
              <p className="p1 !text-11 sm:!text-14 text-cyan-dark capitalize">
                {data.observations}
              </p>
            </div>
            <div className="mb-15">
              <p className="p1 !text-10 !font-semibold text-black opacity-30">HORARIOS</p>
              {data.schedules.map((s, i) => (
                <p key={i} className="p1 !text-12 text-black flex justify-between">
                  <span>{s.day_description}</span>
                  <strong>
                    {s.hour_from} - {s.hour_to}
                  </strong>
                </p>
              ))}
            </div>
            <div className="flex items-center justify-between">
              <div className="mr-50">
                <p className="p1 !text-10 !font-semibold text-black opacity-30">C. POSTAL</p>
                <p className="p1 !text-12 sm:!text-16 text-black">{data.zip_code}</p>
              </div>
              <div>
                <p className="p1 !text-10 !font-semibold text-black opacity-30">Punto HOP</p>
                <p className="p1 !text-12 sm:!text-16 text-black">{data.agency_code}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default Marker;
